// src/components/ExternalRedirect.jsx
import { useEffect } from 'react';

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    // Replace the current history entry with the external URL
    window.location.replace(url);
  }, [url]);
  // Render nothing (or optionally a "Redirecting..." message)
  return null;
};

export default ExternalRedirect;